import request from '@/utils/request'

let SubscriptionApi = {
  /*获取当前商户套餐*/
  getSubscription(data, errorback) {
    return request._get('/supplier/subscription.subscription/index', data, errorback);
  },
  /*获取当前商户的套餐订单列表*/
  getOrderList(data, errorback) {
    return request._get('/supplier/subscription.order/index', data, errorback);
  },
  /*算价接口 - 续费套餐*/
  calculateRenew(data, errorback) {
    return request._post('/supplier/subscription.order/calculate', data, errorback);
  },
  /*算价接口 - 购买名额*/
  calculateAddStaff(data, errorback) {
    return request._post('/supplier/subscription.order/calculate', data, errorback);
  },
  /*创建 Stripe 支付会话（续费/购买名额通用）*/
  createStripeSession(data, errorback) {
    // 后端接口负责算价、创建本地订单并生成 Stripe Checkout Session
    return request._post('/supplier/subscription.order/createStripeSession', data, errorback);
  },
}

export default SubscriptionApi;



// WEBPACK FOOTER //
// ./src/api/subscription.js